import React from "react";
import {
  View,
  StyleSheet,
  Image,
  Text,
  useWindowDimensions,
  Platform,
} from "react-native";

function PrinciplesCard() {
  const { width } = useWindowDimensions();
  const isMobile = width < 991; // You can adjust the breakpoint as needed
  
  return (
    <View style={[styles.container, isMobile && styles.containerMobile]}>
      <View style={[styles.card, isMobile && styles.cardMobile]}>
        <Image
          source={{
            uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/8001f3f550f340582191eaa3d46e843e3efd1079?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc",
          }}
          style={styles.backgroundImage}
        />
        <View style={[styles.cardContent, isMobile && styles.cardContentMobile]}>
          <View style={styles.titleContainer}>
            <Text style={[styles.title, isMobile && styles.titleMobile]}>
              Our{"\n"}Principles
            </Text>
          </View>
          <View style={styles.textContainer}>
            <Text style={[styles.text, isMobile && styles.textMobile]}>
              Built upon the core philosophy of <Text style={styles.bold}>KIY (Keep-It-Yourself)</Text>, this <Text style={styles.bold}>Web3 </Text>
              {!isMobile && "\n"}security framework redefines security standards for the emerging
              {!isMobile && "\n"}"True Web3 Era" by implementing three fundamental security {!isMobile && "\n"}principles: <Text style={styles.bold}>decentralized security</Text>,{" "}
              <Text style={styles.bold}>self-sovereign security</Text>, and{" "}
              <Text style={styles.bold}>user-centric security</Text>.
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    paddingBottom: 40,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  containerMobile: {
    // paddingBottom: 20,
  },
  card: {
    width: "74%",
    flexDirection: "column",
    borderRadius: 10,
    position: "relative",
    height: 320,
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 18,
    gap: 8,
    flexWrap: "wrap",
    alignSelf: "center",
  },
  cardMobile: {
    width: "90%",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 16,
    height: "auto",
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: "100%",
    width: "100%",
    borderRadius: 10,
  },
  cardContent: {
    position: "relative",
    minWidth: 240,
    minHeight: 325,
    width: "100%",
    flex: 1,
    marginLeft: 25,
  },
  cardContentMobile: {
    marginLeft: 0,
    marginTop: 0,
    marginBottom: 30,
    minHeight: "auto",
  },
  titleContainer: {},
  title: {
    marginTop: 15,
    fontSize: 40,
    fontWeight: "700",
    lineHeight: 50,
    letterSpacing: 1,
    color: "rgba(236, 236, 236, 1)",
    fontFamily: "Montserrat, sans-serif",
  },
  titleMobile: {
    fontSize: "20px",
    lineHeight: 30,
  },
  textContainer: {
    marginTop: 25,
  },
  text: {
    width: "90%",
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 27,
    color: "rgba(236, 236, 236, 1)",
    fontFamily: "Montserrat, sans-serif",
  },
  textMobile: {
    fontSize: "12px",
    lineHeight: 22,
  },
  bold: {
    fontWeight: "700",
  },
});

export default PrinciplesCard;
